export default function ({ app }) {
  if (process.client) {
    // Override URL.createObjectURL
    const originalCreateObjectURL = URL.createObjectURL;
    URL.createObjectURL = function (blob) {
      console.log("URL.createObjectURL", blob);

      // Block text/html blobs
      if (blob instanceof Blob && blob.type === "text/html") {
        console.warn(
          "Blocked potentially dangerous Blob URL creation - HTML content detected"
        );
        return "";
      }

      return originalCreateObjectURL.apply(this, arguments);
    };
  }
}
